import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, Typography } from "@mui/material";

import SlidingPanel from "react-sliding-side-panel";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import CheckBox from "../../../../../Supporting files/CheckBox/CheckBox";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";


interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const SelectFeature: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const [clientid, setClientId] = React.useState("");
  const [alternateTreatment, setAlternateTreatment] = React.useState(false);
  const [addQuoteStep, setAddQuoteStep] = React.useState<
    Array<{ insurer: string; premium: string; deleteable: boolean }>
  >([{ insurer: "", premium: "", deleteable: false }]);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  var indents = [];
  for (var i = 0; i < addQuoteStep.length; i++) {
    indents.push(<span className="indent" key={i}></span>);
  }

  const [addFeature, setAddFeature] = useState<
    Array<{
      title: string;
      title_class: string;
      border_class: string;
      data: Array<{
        id: number;
        checkbox_status: boolean;
        title: string;
        description: string;
        value: string;
        fieldType: string;
      }>;
    }>
  >([
    {
      title: "Medical Cover",
      title_class: "blue",
      border_class: "blue",
      data: [
        {
          id: 0,
          checkbox_status: false,
          title: "Pre-existing Diseases",
          description:
            "Coverage for any pre-existing disease is provided to you after a certain waiting period. ",
          value: "Test",
          fieldType: "textInput",
        },
        {
          id: 1,
          checkbox_status: false,
          title: "Ayush/Alternative Treatment Cover",
          description:
            "Any health insurance with the inclusion of AYUSH treatment covers all the alternate medical sciences mentioned in the policy",
          value: "50000",
          fieldType: "dropDown",
        },
        {
          id: 2,
          checkbox_status: false,
          title: "Pre & Post Hospitalisation Expenses",
          description:
            "Coverage against medicinal expenses incurred,including pre and post hospitalization ",
          value: "Test",
          fieldType: "textInput",
        },
        {
          id: 3,
          checkbox_status: false,
          title: "Room Rent",
          description:
            "Room rent limit is one of the most common coverage limitations that you can find under medical insurance plans",
          value: "Test",
          fieldType: "textInput",
        },
      ],
    },
    {
      title: "Emergency Cover",
      title_class: "yellow",
      border_class: "yellow",
      data: [
        {
          id: 0,
          checkbox_status: false,
          title: "Worldwide Emergency Cover",
          description:
            "provides coverage for medical expenses that have been incurred abroad.",
          value: "Test",
          fieldType: "textInput",
        },
        {
          id: 1,
          checkbox_status: false,
          title: "Ambulance Cover",
          description: "Up to Rs. 5,000 (dependent on sum insured)",
          value: "50000",
          fieldType: "dropDown",
        },
      ],
    },
    {
      title: "Hospitalization Cover",
      title_class: "red",
      border_class: "red",
      data: [
        {
          id: 0,
          checkbox_status: false,
          title: "Worldwide Emergency Cover",
          description:
            "provides coverage for medical expenses that have been incurred abroad.",
          value: "Test",
          fieldType: "textInput",
        },
        {
          id: 0,
          checkbox_status: false,
          title: "Ambulance Cover",
          description: "Up to Rs. 5,000 (dependent on sum insured)",
          value: "Test",
          fieldType: "textInput",
        },
      ],
    },
    {
      title: "Maternity Cover",
      title_class: "green",
      border_class: "green",
      data: [
        {
          id: 0,
          checkbox_status: false,
          title: "New Born Child Cover",
          description:
            "Not all health insurance plans cover a newborn from day.",
          value: "Test",
          fieldType: "textInput",
        },
        {
          id: 0,
          checkbox_status: false,
          title: "Ambulance Cover",
          description: "Up to Rs. 5,000 (dependent on sum insured)",
          value: "Test",
          fieldType: "textInput",
        },
      ],
    },
  ]);

  const dropdown_data = [
    { key: "50000", value: "Rs. 50 Lakhs" },
    { key: "60000", value: "Rs. 60 Lakhs" },
    { key: "70000", value: "Rs. 70 Lakhs" },
    { key: "80000", value: "Rs. 80 Lakhs" },
    { key: "90000", value: "Rs. 90 Lakhs" },
    { key: "100000", value: "Rs. 1 Crore" },
  ];

  const updateMasterStateArray = (attrName: any, value: any) => {
    const array_data = [...addFeature];

    if (attrName[2] === "value") {
      console.log(attrName, value);
      //array_data[attrName[0]].data[attrName[1]].value = value;
    } else if (attrName[2] === "checkbox_status") {
      array_data[attrName[0]].data[attrName[1]].checkbox_status = value;
    }

    setAddFeature(array_data);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="slidingPanel"
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div className="select_feature">
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10} className="pt-0">
            <h4 className="mb-3 mt-3">Select Features</h4>
          </Grid>
          <Grid xs={2} textAlign='end' className="mt-2">
            <GridCloseIcon
              onClick={() => {
              value_update(attrName, false);
            }}
            />
          </Grid>
          <Grid xs={12} className="pt-0">
            <hr />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ paddingTop: "0" }}
        >
          <Grid xs={12}>
            <div className="scrollable_area">
              {addFeature.map((data, index) => (
                <div
                  className={"coverage_section mr-3 mb-6 " + data.border_class}
                >
                  <Grid container spacing={3} style={{ alignItems: "center" }}>
                    <Grid
                      xs={12}
                      className={"coverage_heading " + data.title_class}
                    >
                      <h5>{data.title}</h5>
                      {/* <p className={"started_heading " + item.title_class}></p> */}
                    </Grid>
                    {data.data.map((value, indexx) => (
                      <>
                        <Grid xs={8} className="checkbox_feature">
                          <CheckBox
                            title={
                              <p>
                                {value.title}
                                <span>{value.description}</span>
                              </p>
                            }
                            name={index.toString() + indexx.toString()}
                            id={index.toString() + indexx.toString()}
                            value={value.checkbox_status}
                            attrName={[index, indexx, "checkbox_status"]}
                            value_update={updateMasterStateArray}
                            default_check={false}
                          />
                        </Grid>
                        <Grid xs={4}>
                          {value.fieldType == "textInput" ? (
                            <RKTextField
                              class_name="inputField"
                              title="Value"
                              value={value.value}
                              attrName={[index, indexx, "value"]}
                              value_update={updateMasterStateArray}
                              warn_status={false}
                            />
                          ) : (
                            <SelectDropdown
                              class_name="inputField"
                              title="Policy"
                              value={value.value}
                              attrName={[index, indexx, "value"]}
                              value_update={updateMasterStateArray}
                              dropdown_data={dropdown_data}
                              warn_status={false}
                            />
                          )}
                        </Grid>
                        <Grid xs={12} className="mb-0 pt-0 pb-0">
                          {indexx + 1 === data.data.length ? null : <hr />}
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </div>
              ))}
            </div>
          </Grid>

          <Grid xs={12} className="footer_sec">
            <Link className="save_btn">Submit</Link>
          </Grid>
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default SelectFeature;
